<template>
  <th
    v-if="sortingParam"
    tabindex="0"
    class="cursor-pointer sort-header"
    :class="classList"
    @click="handleDateHeaderClick"
    @keypress.enter="handleDateHeaderClick"
  >
    <span v-html="textContent"></span>
    <span
      :class="{
        desc: descOrder && currentSortingParamValue.includes(sortingParam),
      }"
      class="inline-block indicator"
      >▲</span
    >
  </th>
  <th v-else :class="classList" v-html="textContent"></th>
</template>

<script>
export default {
  props: {
    textContent: {
      type: String,
      required: true,
    },
    classList: {
      type: String,
      required: false,
      default: "",
    },
    sortingParam: {
      type: String,
      required: false,
    },
    descOrder: {
      type: Boolean,
      required: false,
    },
    currentSortingParamValue: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      state: null,
    }
  },
  created() {
    if (this.descOrder) {
      this.state = `-${this.sortingParam}`
    } else {
      this.state = this.sortingParam
    }
  },
  methods: {
    handleDateHeaderClick() {
      if (this.descOrder) {
        this.state = this.sortingParam
      } else {
        this.state = `-${this.sortingParam}`
      }
      const obj = { value: this.state, sortingParam: this.sortingParam }
      this.$emit("SORT_BY", obj)
    },
  },
}
</script>

<style scoped>
.indicator {
  transition: transform 0.3s ease-out;
}

.desc {
  transform: rotate(180deg);
}

.sort-header:hover,
.sort-header:active,
.sort-header:focus {
  filter: brightness(0.9);
}
</style>
